import React, { Component } from "react";
import "./Tigerboxes.scss";
import Strings from "../../config/Strings";
import {Helmet} from "react-helmet";
import {withToast} from "../../util/ToastService";

class TigerboxProductPass extends Component {
    constructor(props) {
        super(props);
        const queryParams = new URLSearchParams(window.location.search);
        //https://info.tiger.media/tigerbox-id/?batchCode=V1-20250417-0008-10-0178&deviceId=0624013304413474
        this.state = {
            batchCode: queryParams.get("batchCode") ? queryParams.get("batchCode") : "",
            deviceId: queryParams.get("deviceId") ? queryParams.get("deviceId") : "",
        };
    }

    async componentDidMount() {
        document.title = "Infos zu deiner Tigerbox :: tiger.media";
    }

    scrollTo() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
                <div className={"product-pass-container"}>
                    <Helmet>
                        <meta charSet="utf-8"/>
                        <title>{Strings.SEARCH_PAGE_TITLE}</title>
                        <meta name="description" content={Strings.SEARCH_PAGE_DESCRIPTION}/>
                        <meta name="keywords"
                              content={Strings.SEARCH_PAGE_KEYWORDS}/>
                    </Helmet>

                        <div className="product-overview">
                            <h3>Informationen zu deiner tigerbox</h3>
                            <div className={"tigerbox-identifier"}>
                                <b>Geräte-ID:</b> {this.state.deviceId}
                            </div>
                            <div className={"tigerbox-batchcode"}>
                                <b>Batchcode:</b> {this.state.batchCode}
                            </div>
                        </div>
                </div>
        );
    }
}

export default withToast(TigerboxProductPass);
